<template>
    <div class="flex flex-col text-default mx-24">
        <span class="font-black text-4xl font-title">About Me</span>
        <span class="text-lg font-text">Hello!  I am Connor Klaassen, a computer science student at Purdue
           University. I am currently working on gaining hands-on experience as
           a developer.  Along with my studies, I am building Keryx, a company
           that is designing a workspace to facilitate complex, relationship
           based communications.</span>
    </div>
</template>

<script>

export default {
  name: 'LongerAboutMe'
}
</script>
